// extracted by css-extract-rspack-plugin
export default {"Wrapper":"IuHSJ","Main":"vrWz9","Sidebar":"FrIKh","Content":"HGIZs"};